import { render, staticRenderFns } from "./readonly.vue?vue&type=template&id=7c63c4c6&scoped=true&"
import script from "./readonly.vue?vue&type=script&lang=js&"
export * from "./readonly.vue?vue&type=script&lang=js&"
import style0 from "./readonly.vue?vue&type=style&index=0&id=7c63c4c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c63c4c6",
  null
  
)

export default component.exports